module.exports = __webpack_public_path__ + "footer-03.svg?fc34174a2316e873431ace74ed8bc507";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer-03.svg
// module id = 86
// module chunks = 0